import { Box, Flex, ThemeColorVariable } from "@caspeco/casper-ui-library";
import Spinner from "./spinner";

type props = {
	overlayScreen?: boolean;
};

export const LoadingScreen = ({ overlayScreen }: props) => {
	return (
		<Box
			height="100vh"
			pos={overlayScreen ? "absolute" : undefined}
			backgroundColor={overlayScreen ? ThemeColorVariable.BackgroundDisabled : undefined}
			top={overlayScreen ? 0 : undefined}
			left={overlayScreen ? 0 : undefined}
			zIndex={overlayScreen ? 100 : undefined}
			width={overlayScreen ? "100vw" : undefined}
		>
			<Flex justify="center" align="center" h="100%">
				<Spinner size="lg" />
			</Flex>
		</Box>
	);
};
